
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { JobDetailedStop } from '@/models/jobDetailed';
import AttributesAutocompleteField from '@/components/fields/AttributesAutocompleteField.vue';
import AttributesTextBtn from '@/components/btns/AttributesTextBtn.vue';
import _uniqueId from 'lodash/uniqueId';

@Component({
  components: {
    AttributesAutocompleteField,
    AttributesTextBtn,
  },
})
export default class AttributesFieldset extends Vue {
  @Prop(Object) public value: JobDetailedStop;
  @Prop(Boolean) public isAddStairs: boolean;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public isAddStairsDisabled = false;

  get jobStop() {
    return this.value;
  }

  set jobStop(value) {
    this.$emit('input', value);
  }

  @Watch('jobStop.attributes')
  @Watch('jobStop.services')
  private isAddStairsDisabledWatcher() {
    this.isAddStairsDisabled =
      this.jobStop.attributes.indexOf('SSC') !== -1 && !!this.jobStop.services.find(item => item.name === 'STAIRS');
  }

  public handleAddStairsServiceClick() {
    if (this.jobStop.attributes.indexOf('SSC') === -1) {
      this.jobStop.attributes.push('SSC');
    }
    if (!this.jobStop.services.find(item => item.name === 'STAIRS')) {
      this.jobStop.services.push({
        name: 'STAIRS',
        quantity: 1,
        _clientId: _uniqueId(),
      });
    }
  }
}
